import React, { useState } from "react";
import { Grid, Typography, Button, Modal, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import {
  Star,
  Note,
  AttachMoney,
  School,
  House,
  MenuBook,
  PeopleOutline,
} from "@material-ui/icons";
import { useAuth } from "../../../contexts/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { addBookmark, removeBookmark } from "../../../redux/firebaseCalls";

import CardResultList from "./CardResultList";
import CardResultText from "./CardResultText";

//import univData from "../../../univdata.json";

const useStyles = makeStyles((theme) => ({
  subtitle: {
    marginTop: theme.spacing(3),
  },
  bookmarkButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
  starIcon: {
    color: (props) => (props.bookmark ? "#F6BE00" : "grey"),
  },
  gridContainer: {
    marginTop: theme.spacing(5),
  },
  cardTitle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    color: "white",
  },
  cardTitleText: {
    marginLeft: theme.spacing(2),
  },
  modalContainer: {
    position: "absolute",
    width: 500,
    height: 200,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    margin: "auto",
  },
  modalButtonDiv: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(5)
  },
}));

export default function SearchResult({ data }) {
  const { currentUser } = useAuth();
  const dispatch = useDispatch();
  const bookmarkUniv = useSelector((state) => state.bookmark.bookmarkList);
  const [bookmark, setBookmark] = useState(bookmarkUniv.includes(data.name));
  const [openModal, setOpenModal] = useState(false);
  const classes = useStyles({ bookmark });

  const handleRemove = () => {
    setBookmark(false);
    removeBookmark(data.name, currentUser.uid, dispatch);
    setOpenModal(false);
  };

  const handleBookmark = () => {
    if (!bookmark) {
      setBookmark(true);
      addBookmark(data.name, currentUser.uid, dispatch);
    } else {
      setOpenModal(true);
    }
  };

  return (
    <div>
      <Typography variant="h2" align="center" gutterBottom>
        {data.name}
      </Typography>
      <Typography
        variant="h4"
        align="center"
        color="textSecondary"
        gutterBottom
        className={classes.subtitle}
      >
        University Info
      </Typography>
      {currentUser && (
        <div className={classes.bookmarkButton}>
          <Button
            endIcon={<Star className={classes.starIcon} />}
            onClick={handleBookmark}
          >
            Add to Bookmark
          </Button>
        </div>
      )}
      <Grid container spacing={2} className={classes.gridContainer}>
        <Grid item xs={12} lg={6}>
          <CardResultList
            title="Documents"
            data={data.document}
            icon={<Note />}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CardResultText title="Fees" data={data.fee} icon={<AttachMoney />} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CardResultList
            title="Scholarship"
            data={data.scholarship}
            icon={<School />}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CardResultList
            title="Housing"
            data={data.housing}
            icon={<House />}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CardResultList
            title="Prep. Course"
            data={data.prepcourse}
            icon={<MenuBook />}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <CardResultText
            title="Study Group"
            data={data.studygroup}
            icon={<PeopleOutline />}
            button={true}
          />
        </Grid>
      </Grid>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Container className={classes.modalContainer}>
          <Typography variant="h5">
            Are you sure you want to remove this university from your bookmarked
            list?
          </Typography>
          <div className={classes.modalButtonDiv}>
            <Button
              color="secondary"
              variant="contained"
              style={{marginRight: 10}}
              onClick={handleRemove}
            >
              Proceed
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenModal(false)}
            >
              Cancel
            </Button>
          </div>
        </Container>
      </Modal>
    </div>
  );
}
